import React from "react";

import { DashboardOverview } from "./dashboardType";

interface Props {
  data: DashboardOverview;
}

const formatCurrency = (
  value: number
) =>
  new Intl.NumberFormat(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }
  ).format(value || 0);

const OverviewCards: React.FC<Props> = ({
  data,
}) => {
  const cards = [
    {
      title: "Total Customers",
      value: data.Total_Customers,
    },

    {
      title: "Active Customers",
      value: data.Active_Customers,
    },

    {
      title: "New Customers",
      value: data.New_Customers,
    },

    {
      title: "Existing Customers",
      value: data.Existing_Customers,
    },

    {
      title: "Total Children",
      value: data.Total_Children,
    },

    {
      title: "Active Subscriptions",
      value:
        data.Active_Subscriptions,
    },

    {
      title: "Collection",
      value: formatCurrency(
        data["Today's_Collection"]
      ),
      currency: true,
    },

    {
      title: "Pending Amount",
      value: formatCurrency(
        data.Pending_Amount
      ),
      currency: true,
    },

    {
      title: "Total Renewals",
      value: data.Total_Renewals,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.title}
          className="rounded-xl border bg-white p-5 shadow-sm"
        >
          <p className="text-sm font-medium text-gray-500">
            {card.title}
          </p>

          <p className="mt-2 text-2xl font-bold text-gray-900">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default OverviewCards;